export interface ICprScoreAudit {
    centerId: number,
    centerAlias: string,
    invoiceDate: string,
    transplantDate: string,

    intendedDonorId: string,
    intendedDonorAlias: string,
    intendedDonorAbo: string,

    recipientId: number,
    recipientAlias: string,
    recipientAbo: string,
    patientType: number,
    patientTypeDescription: string,

    epletMm: string,
    hasIntendedDonor: boolean,
    isMicrositeFacilitated: boolean,
    isIncluded: boolean,
    isDirectDonation: boolean
    isCompatiblePair: boolean,
    isFavorablePair: boolean,
    isTranplanted: boolean
}